import { environment } from '@environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class ReviewTimeService {
    // eslint-disable-next-line
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    saveReviewTime(analysisId, time) {
        return this.httpClient.patch(environment.api.base + 'efas/' + analysisId + '/save-time?seconds=' + time, {});
    }
}
ReviewTimeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReviewTimeService_Factory() { return new ReviewTimeService(i0.ɵɵinject(i1.HttpClient)); }, token: ReviewTimeService, providedIn: "root" });
